"use client";

import { c as _c } from "react/compiler-runtime";
import { MetaDot } from "@/components/ui/meta-dot";
import { IconCryptoWallet } from "@central-icons-react/square-outlined-radius-0-stroke-1.5";
import type { OrganizationWallet } from "@/types/wallet";
import { getInlineBadgeClassName, type InlineBadgeVariant } from "@/components/ui/shared-badge-styles";
import { formatAddress } from "@/lib/utils";
import { useOrganizationWalletModalStore } from "@/stores/organizationWalletModalStore";
export const ORGANIZATION_WALLET_BADGE_OPEN_EVENT = "b3:organization-wallet-badge-open";
export function OrganizationWalletBadge(t0) {
  const $ = _c(23);
  const {
    wallet,
    clickable: t1,
    variant: t2,
    showAddress: t3
  } = t0;
  const clickable = t1 === undefined ? true : t1;
  const variant = t2 === undefined ? "summary" : t2;
  const showAddress = t3 === undefined ? true : t3;
  const openWallet = useOrganizationWalletModalStore(_temp);
  let t4;
  if ($[0] !== wallet.address) {
    t4 = formatAddress(wallet.address, 4, 4);
    $[0] = wallet.address;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const truncatedAddress = t4;
  let t5;
  if ($[2] !== openWallet || $[3] !== wallet) {
    t5 = () => {
      window.dispatchEvent(new CustomEvent(ORGANIZATION_WALLET_BADGE_OPEN_EVENT, {
        detail: {
          walletId: wallet.id
        }
      }));
      openWallet(wallet);
    };
    $[2] = openWallet;
    $[3] = wallet;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const handleOpenWalletDetails = t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <IconCryptoWallet className="h-3 w-3 flex-shrink-0 opacity-70" />;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== wallet.name) {
    t7 = <span className="flex-shrink-0 font-medium">{wallet.name}</span>;
    $[6] = wallet.name;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== showAddress || $[9] !== truncatedAddress || $[10] !== wallet.address) {
    t8 = showAddress ? <><MetaDot /><span className="min-w-0 truncate font-mono opacity-80" title={wallet.address}>{truncatedAddress}</span></> : null;
    $[8] = showAddress;
    $[9] = truncatedAddress;
    $[10] = wallet.address;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7 || $[13] !== t8) {
    t9 = <>{t6}{t7}{t8}</>;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const badgeContent = t9;
  let t10;
  if ($[15] !== badgeContent || $[16] !== clickable || $[17] !== handleOpenWalletDetails || $[18] !== variant || $[19] !== wallet.address || $[20] !== wallet.id || $[21] !== wallet.name) {
    t10 = <>{clickable ? <button type="button" onClick={handleOpenWalletDetails} className={getInlineBadgeClassName({
        variant,
        interactive: true,
        className: "overflow-hidden"
      })} title={`${wallet.name} (${wallet.id}) - ${wallet.address}`}>{badgeContent}</button> : <span className={getInlineBadgeClassName({
        variant,
        className: "overflow-hidden"
      })} title={`${wallet.name} (${wallet.id}) - ${wallet.address}`}>{badgeContent}</span>}</>;
    $[15] = badgeContent;
    $[16] = clickable;
    $[17] = handleOpenWalletDetails;
    $[18] = variant;
    $[19] = wallet.address;
    $[20] = wallet.id;
    $[21] = wallet.name;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}
function _temp(state) {
  return state.openWallet;
}